<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <div class="header-search-title">お知らせ</div>
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
        >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <main class="" id="main">
          <div class="box02 white">
            <div class="box02-hdg">
              <span v-if="data.classification === 3 || data.classification === 2"
                class="icon-label" :class="data.classification === 3 ? 'red' : 'gray'"
              >{{ data.classification_name }}</span>
              <span class="txt-sup">{{data.publication_day}}</span>
              <span v-if="data.category_name" class="txt-sup">{{data.category_name}}</span>
            </div>
            <div class="box02-body" id="scroll-target"
              style="height:calc(100vh - 100px);"
              @scroll="handleScroll"
              >
              <div class="information-detail-inner">
                <p class="txt txt-blue mb32"><router-link to="/pc/information-list">お知らせ一覧へ</router-link></p>

                <h2 class="hdg03">{{data.title}}</h2>
                <div v-html="data.detail"></div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import { InformationDetail } from '@/logic/information/InformationDetail'

import PCMenu from '@/components/pc/popup/PCMenu.vue'

export default defineComponent({
  components: {
    PCMenu
  },
  props: {
    infoId: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {
    return { ...InformationDetail(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#main {
  width: 100%;
  margin-left: 0;
}
.box02-hdg {
  .icon-label,
  .txt-sup {
    display: inline-block;
    vertical-align: middle;
  }
  .txt-sup {
    margin: 0 0 0 20px;
  }
}
.box02-body {
  overflow: auto;
  padding: 0 40px 80px;
  border-radius: 0!important;
  .information-detail-inner {
    max-width: 780px;
    width: 100%;
    margin: 0 auto;
    padding: 40px 0;
  }
  .hdg03 {
    margin-bottom: 28px; 
  }
  .hdg05 {
    margin-bottom: 28px; 
  }
  .txt {
    margin-bottom: 72px;
  }
}
</style>
